<script lang="ts">
	import { prefersReducedMotion } from "svelte/motion";
	import type { IconProps } from "../../../vite/Icon";
	import HourglassIcon from "../../assets/icons/Hourglass.svg#icon";
	import LoadingIcon from "../../assets/icons/Loading.svg#icon";
	import loading from "../../assets/images/PawLoading.svg";

	const { doglioLogo, ...attrs }: IconProps & { doglioLogo?: boolean } = $props();
</script>

{#if prefersReducedMotion.current}
	<HourglassIcon {...attrs} />
{:else if doglioLogo}
	<img src={loading} draggable={false} class="select-none" width={75} height={75} aria-hidden="true" alt="" />
{:else}
	<LoadingIcon {...attrs} />
{/if}
